import { render, staticRenderFns } from "./SharedCategory.vue?vue&type=template&id=66100f26&"
import script from "./SharedCategory.vue?vue&type=script&lang=js&"
export * from "./SharedCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports